import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const toastNotificationFn = /* @__PURE__ */ createRecipe('toast-notification', {}, [])

const toastNotificationVariantMap = {}

const toastNotificationVariantKeys = Object.keys(toastNotificationVariantMap)

export const toastNotification = /* @__PURE__ */ Object.assign(memo(toastNotificationFn.recipeFn), {
  __recipe__: true,
  __name__: 'toastNotification',
  __getCompoundVariantCss__: toastNotificationFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: toastNotificationVariantKeys,
  variantMap: toastNotificationVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, toastNotificationVariantKeys)
  },
  getVariantProps: toastNotificationFn.getVariantProps,
})